export default {
    settings: {
        title: 'Настройки',
        description: 'Настраивайте и просматривайте в режиме реального времени',
        language: {
           title: 'Язык',
           russian: 'Русский',
           english: 'English'
        },
        workspace: 'Рабочая область',
        fix_panel: 'Зафиксировать левую панель',
        color_scheme: {
            title: 'Цветовая схема',
            standart: 'Стандартнаая',
            dark: 'Темная',
        },
        stringHeight: 'Макс число подстрок в строке',
        help: 'Порядок следования колонок может быть изменен - для этого выберите нужную колонку и перетащите ее вверх или вниз.',
        notification: 'Уведомления',
    }
};
